import { IconButton as MuiIconButton, styled } from "@mui/material";

export const FilterWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1.5rem;
  padding: 2rem;
`;

export const IconButton = styled(MuiIconButton)(({ theme }) => ({
  color: theme.palette.common.white,
}));
